import { zodResolver } from '@hookform/resolvers/zod'
import { StringFormatter } from '@repo/toolkit/string'
import { FileTypeEnum } from '@repo/toolkit/types'
import { UploadIcon } from '@repo/ui/icons'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import { DpaeAcknowledgmentReceiptInput } from '../../../lib/types/models/mission-tracking/mission-tracking-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { FILE_VALIDATION } from '../../../lib/utils/validations/file.validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledFileInput from '../../elements/inputs/controlled-file-input'
import ValidationButtons from '../../elements/validation-buttons'

const formSchema: ZodType<DpaeAcknowledgmentReceiptInput> = z.object({
  file: FILE_VALIDATION({ error: 'Le fichier est obligatoire' })
})

export const DapeAcknowledgmentReceiptForm = ({
  className,
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<DpaeAcknowledgmentReceiptInput, true>) => {
  const form = useForm<DpaeAcknowledgmentReceiptInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}
        className={className}
      >
        <div className={'p-4'}>
          <FormField
            control={form.control}
            name={'file'}
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledFileInput
                    required
                    previewOnClick
                    icon={UploadIcon}
                    onChange={field.onChange}
                    types={[FileTypeEnum.XML]}
                    label={'Télécharger le document'}
                    files={field?.value ? [field?.value] : undefined}
                    onFilesChange={(files) => field.onChange(files[0], { shouldValidate: true })}
                    placeholder={StringFormatter.isRequired('Glisser-déposer ou parcourir', true)}
                  />
                </FormControl>
              </FormItem>
            )}
          />
        </div>

        <ValidationButtons {...validationButtonProps} hasBorderTop />
      </form>
    </Form>
  )
}
